<template>
  <div id="CreateCustomRoleAdmin" class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="pageTitle">Create new Custom Role</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-header">Please provide Custom Role name</div>
          <div class="card-body">
            <div class="col-md-8">
              <!-- <h3>Please provide Custom Role name</h3> -->
              <!-- Create form -->
              <form @submit.prevent="createCustomRole">
                <div class="form-group">
                  <label for="name">
                    Custom Role name
                    <span class="text-danger">*</span>
                  </label>
                  <input type="text" v-model="name" class="form-control" :class="{ 'is-invalid': $v.name.$error, 'is-valid': !$v.name.$invalid }" />
                  <div class="invalid-feedback">
                    <span v-if="!$v.name.required">Custom Role name is required.</span>
                    <span v-if="!$v.name.minLength">Custom Role name must be at least {{ $v.name.$params.minLength.min }} letters.</span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="name">Custom Role description</label>
                  <textarea v-model="description" class="form-control" rows="3" />
                  <!-- <div class="invalid-feedback">
                          <span v-if="!$v.description.minLength">Custom Role description must be at least {{ $v.name.$params.minLength.min }} letters.</span>
                      </div>-->
                </div>
                <button class="btn btn-danger btn-block">Create new Custom Role</button>
              </form>
              <!-- / Create form -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "CreateCustomRoleAdmin",

  data() {
    return {
      customRoles: [],
      name: "",
      description: "",
    };
  },

  /* mounted() {
    let loading = this.$loading.show();
    axios.get("/admin/customRoles").then(res => {
      this.customRoles = res.data.customRoles;
      loading.hide();
    });
  }, */

  methods: {
    createCustomRole() {
      let loading = this.$loading.show();
      this.$v.$touch();
      if (this.$v.$invalid) {
        loading.hide();
        return;
      }
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("description", this.description);
      axios.post("admin/custom-role/create", formData).then((res) => {
        if (res.data.status == "success") {
          //res.data.custom-role.subCategories = [];
          //this.customRoles.push(res.data.custom-role);
          this.$swal("", `${this.name} created successfully`, "success");
          this.$router.push({ name: "CustomRolesAdmin" });
        } else {
          this.$swal("", res.data.message, "error");
        }
        loading.hide();
      });
    },
  },

  computed: {
    client() {
      return this.$store.state.client;
    },
  },

  created() {
    //this.$store.commit("SET_LAYOUT", "agent-layout");
  },

  validations: {
    name: { required, minLength: minLength(2) },
    //description: { minLength: minLength(2) }
  },
};
</script>

